/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  let imgProductZoom = document.querySelectorAll('.product__zoomImage');

  imgProductZoom.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      const clickedElement = e.target;
      const modal = clickedElement.closest('.product__zoomImage_modal');
      const buttonCloseModal = modal.querySelector('.product-modal__close');

      buttonCloseModal.click();
    });
  });

  



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


(function() {
  let read_more_button = document.querySelectorAll('.read_more_button');

  read_more_button.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      const read_more_button = e.currentTarget;

      let btn_status = read_more_button.getAttribute('aria-expanded'),
          read_more_wrapper = read_more_button.previousElementSibling;
          
      if(btn_status == 'false'){
        read_more_wrapper.style.display = "block";
        read_more_button.setAttribute('aria-expanded', true);
      }else {
        read_more_wrapper.style.display = "none";
        read_more_button.setAttribute('aria-expanded', false);
      }
    });
  });
})();
